import { settingsService } from '../services/settingsService';

let cachedKey: string | null = null;
let loadingPromise: Promise<string> | null = null;

export async function getGoogleMapsApiKey(): Promise<string> {
  if (cachedKey !== null) return cachedKey;
  if (loadingPromise) return loadingPromise;

  loadingPromise = (async () => {
    try {
      const settings = await settingsService.getSettingValue('settings_system_preferences', {});
      const key = (settings as any)?.googleMapsApiKey as string | undefined;
      if (key && key.trim()) {
        cachedKey = key.trim();
        return cachedKey;
      }
    } catch {}
    const envKey = import.meta.env.VITE_GOOGLE_MAPS_API_KEY || '';
    if (envKey) cachedKey = envKey;
    return envKey;
  })();

  return loadingPromise;
}

export function getGoogleMapsApiKeySync(): string {
  if (cachedKey) return cachedKey;
  return import.meta.env.VITE_GOOGLE_MAPS_API_KEY || '';
}
